// ImportSuppliersButton.js

import React, { useState } from "react";
import PropTypes from "prop-types";
import MDButton from "components/MDButton";
import api from "../../services/api";
import { useCompany } from "../../context/CompanyContext";
import { useSnackbar } from "../../context/SnackbarContext";
import { Add as AddIcon } from "@mui/icons-material";
import { useLanguage } from "context/LanguageContext";

const ImportSuppliersButton = ({ onImportSuccess, children }) => {
  const [loading, setLoading] = useState(false);
  const { selectedCompany } = useCompany();
  const showSnackbar = useSnackbar();
  const { t } = useLanguage();

  const handleImport = async () => {
    if (!selectedCompany) {
      showSnackbar(t("selectCompanyFirst") || "Please select a company first", "error");
      return;
    }
    setLoading(true);
    try {
      const response = await api.post("/api/import_suppliers/", {
        company_id: selectedCompany.id,
      });

      const result = response?.data;

      if (result?.success) {
        const summary = result?.summary || {};
        const created = summary?.created || 0;
        const updated = summary?.updated || 0;
        const unchanged = summary?.unchanged || 0;
        const failed = summary?.failed || 0;
        const importedCount = result?.importedCount || created + updated;

        const message = t("importSummaryMessage")
          .replace("{created}", created)
          .replace("{updated}", updated)
          .replace("{unchanged}", unchanged)
          .replace("{failed}", failed);
        showSnackbar(message, failed > 0 ? "warning" : importedCount > 0 ? "success" : "info");
        onImportSuccess?.(result);
      } else {
        showSnackbar(`Error: ${result?.error || "Unknown error"}`, "error");
      }
    } catch (error) {
      console.error("Error importing suppliers:", error);
      showSnackbar(t("errorOccurred") || "Import failed due to server error.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MDButton onClick={handleImport} disabled={loading} variant="contained" color="info">
      {loading ? t("importingSuppliers") : children || t("importSuppliers")}
    </MDButton>
  );
};

// Define prop types
ImportSuppliersButton.propTypes = {
  onImportSuccess: PropTypes.func,
  children: PropTypes.node,
};

export default ImportSuppliersButton;
